module.exports = __webpack_public_path__ + "static/media/emptyUCC.41c3eb2a.svg";